export enum AccountAnalyticTypeEnum {
    Agreement,
    VatRate,
    TaxAuthority,
    MoneyMovementArticle,
    CashBox,
    CustomerVendor,
    Warehouse,
    Product,
    BankAccount,
    CashRegister,
    Currency,
    CashFlowItem,
    Contracts,
    Customers,
    ActiveItem,
    Accrual,
    Employee,
    CustomersPersons,
    Vendors,
    AnalyticsTypeOfIncomeExpenseItem,
    FixedAssets,
    ExpenseItem,
    IntangibleAsset,
    PassiveItem,
    Tax,
    TaxGroup,
    Account,
    Persons,
    Vat,
    IncomeItem,
    Unit,
    Divisions,
    Bank,
    CustomerEmployee,
    Convert,
    TaxType

}